import {View, Platform} from 'react-native';
import * as React from 'react';
import Screen from '../../shared/components/screen';
import {DeviceSize} from '../../shared/theme/helpers';
import {Props} from './model';
import {ResponsiveView} from '../../shared/components/responsiveView';
import NotificationsDesktopView from './components/list/desktop';
import {Button} from '../../shared/components/button';
import NotificationsMobileView from './components/list/mobile';
import {Text} from '../../shared/components/text';
import {LoadableContent} from '../../shared/components/loadableContent';
import {CustomScrollView} from '../../shared/components/scrollView';
import getStyles from './styles';
import {ReadAllButton} from './components/readAll';

export default ({notifications, showMore, allShown}: Props) => {
  const styles = getStyles();

  return (
    <Screen>
      <CustomScrollView
        onEndReached={!allShown ? showMore : undefined}
        contentInsetAdjustmentBehavior='automatic'
        contentContainerStyle={styles.contentContainer}>
        <View style={styles.sectionContainer}>
          {Platform.OS !== 'web' ? (
            <View style={styles.allToReadMobileContainer}>
              <ReadAllButton />
            </View>
          ) : null}
          <LoadableContent loading={!notifications}>
            <ResponsiveView only={[DeviceSize.desktop]}>
              <Text testID='notifications-section-title-id' style={styles.sectionTitle}>
                Уведомления
              </Text>
            </ResponsiveView>
            <View>
              {notifications?.length === 0 ? (
                <Text testID='no-notifications-title-id' style={styles.noData}>
                  У вас пока нет уведомлений
                </Text>
              ) : null}
              {notifications && notifications?.length > 0 ? (
                <View>
                  <ResponsiveView only={[DeviceSize.desktop]}>
                    <NotificationsDesktopView notifications={notifications} />
                  </ResponsiveView>
                  <ResponsiveView exclude={[DeviceSize.desktop]}>
                    <NotificationsMobileView notifications={notifications} />
                  </ResponsiveView>
                </View>
              ) : null}
            </View>
            {!allShown && Platform.OS === 'web' ? (
              <View style={styles.loadMoreWrapper}>
                <ReadAllButton />
                <Button
                  id='notifications-more'
                  onPress={showMore}
                  style={styles.loadMoreButton}
                  text='Показать еще'
                  type='secondary'
                />
              </View>
            ) : null}
          </LoadableContent>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
